export const OUTCOME = {
  OK_TEXT: 'Close'
}

export const DECIDE = {
  CANCEL_TEXT: 'Cancel',
  OK_TEXT: 'Confirm'
}
